<template>
    <div class="customer-stage">
        <div class="content">
            <div class="top-content">
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content-one">
                            <h4 style="padding-left: 29px">未知等级</h4>
                            <div class="tip-content">该等级为特殊等级不支持改名。该等级为特殊等级不支持改名。受众数据被记录到系统，等级更新需要时间，会处于未知等级，每天凌晨定时更新。
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="bottom-content">
                <el-row>
                    <el-col :span="18">
                        <el-form>
                            <div class="el-form-item">
                                <div class="date-select">
                                    <label class="date-label">时间</label>
                                    <el-select v-model="datevalue" clearable placeholder="请选择">
                                        <el-option v-for="item in options" :key="item.datevalue" :label="item.label"
                                                   :value="item.datevalue">
                                        </el-option>
                                    </el-select>
                                </div>
                                <el-button type="primary" class="add-btn btn-right" @click="addStage">新建等级</el-button>
                            </div>
                            <div class="el-form-item_content">
                                <el-table :data="formInline.stage" class="stageTable" style="margin:0">
                                    <el-table-column label="等级名称" width="300">
                                        <template slot-scope="scope">
                                            <el-input placeholder="请输入内容" style="width:120px;" maxlength="10"
                                                      v-model="scope.row.level"
                                                      clearable type="text">
                                            </el-input>
                                            <!-- <span>LV{{scope.row.level}}</span> -->
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="活跃度区间">
                                        <template slot-scope="scope">
                                            <div style="display: flex;justify-content: flex-start; flex-direction: row">
                                                <div class="stage-span" v-if="scope.$index==0">
                                                    {{scope.row.stage_min_number}}
                                                </div>
                                                <el-input-number :disabled="true" v-else class="prize-count-special"
                                                                 :value="scope.row.stage_min_number"
                                                                 controls-position="right">
                                                </el-input-number>
                                                <span class="stage-span">&lt;活跃度&lt; =</span>
                                                <div class="stage-span"
                                                     v-if="scope.$index==(formInline.stage.length-1)||formInline.stage.stage_max_number==2147483647">
                                                    {{scope.row.stage_max_number}}
                                                </div>
                                                <el-input-number v-else class="prize-count-special"
                                                                 v-model="scope.row.stage_max_number"
                                                                 @change="handleChange($event,scope.$index)"
                                                                 controls-position="right">
                                                </el-input-number>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column width="150" label="操作"
                                                     style="display: flex;justify-content: center">
                                        <template slot-scope="scope">
                                            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                                <div class="op-link">
                                                    <i v-if="scope.$index==(formInline.stage.length-1)&&scope.$index!=0"
                                                       class=""
                                                       style="font-size: 14px;font-style: normal"
                                                       @click="deleteRow(scope.$index, formInline.stage)">删除</i>
                                                </div>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <el-button type="primary" style="margin-top:30px;position: relative;right: 28px;"
                                       class="second-page-btn"
                                       :disabled="isDisable" @click="saveStage()">保存
                            </el-button>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
  import { getCusStageList, editCustomerStage } from '@/api/set.js';

  export default {
    name: 'customerStage',
    data() {
      return {
        // stageL:'',
        isDisable: false,
        levelvule: '',
        list: [],
        datenum: '',
        options: [{
          datevalue: '1',
          label: '近1个月'
        }, {
          datevalue: '2',
          label: '近3个月'
        }, {
          datevalue: '3',
          label: '近6个月'
        }, {
          datevalue: '4',
          label: '近1年'
        }],
        datevalue: '4',
        // level: ['LV1', 'LV2', 'LV3', 'LV4', 'LV5', 'LV6'],
        formInline: {
          stage: [{
            level: '',
            stage_min_number: '',
            stage_max_number: ''
          }]
        }
      };
    },
    methods: {
      //  changestage(event) {
      //          this.datevalue = event.target.value;
      //          console.log(this.datevalue)
      //  },
      //添加等级
      addStage() {
        if (this.formInline.stage.length >= 6) {
          _g.toastMsg('error', '最多添加六个等级');
          return;
        }
        if (this.formInline.stage.length == 0) {
          this.levelvule = 'LV1';
        } else {
          this.levelvule = '';
        }
        this.formInline.stage.push({
          level: this.levelvule,
          stage_min_number: '-∞',
          stage_max_number: '+∞'
        });
        // console.log("eee"+stageL)
      },
      deleteRow(index, rows) {
        // this.stageL=rows.length-2;
        if (this.formInline.stage.length <= 1) {
          _g.toastMsg('error', '至少要有一个等级');
          return;
        }
        rows.splice(index, 1);
        this.formInline.stage[this.formInline.stage.length - 1].stage_max_number = '+∞';
      },
      handleChange(value, index) {
        // if (index > 0) {
        //   if (value < this.formInline.stage[index].stage_min_number) {
        //       _g.toastMsg('error','最大值不能小于最小值')
        //     return
        //   }
        // }
        // 让下一行的最小值变成当前输入框中的值
        this.formInline.stage[index + 1].stage_min_number = value;
      },
      // 点击确定
      saveStage() {
        this.isDisable = true;
        setTimeout(() => {
          this.isDisable = false;
        }, 1000);
        let stagelist = [];
        for (let list of this.formInline.stage) {
          // if(list.stage_min_number=='-∞'){
          //   list.stage_min_number=-2147483647;
          // }
          //  if(list.stage_max_number=='+∞'){
          //   list.stage_max_number=2147483647;
          // }
          if (list.level == '') {
            _g.toastMsg('error', '等级名称不能为空');
            return;
          }
          if (list.stage_max_number <= list.stage_min_number && list.stage_max_number != '+∞' && list.stage_min_number != '-∞') {
            _g.toastMsg('error', '最大值不能小于最小值');
            return;
          }
          stagelist.push({
            id: list.id,
            stageName: list.level,
            stageActivityStart: list.stage_min_number,
            stageActivityEnd: list.stage_max_number
          });
        }
        let modelId = this.$route.query.id;
        let data = {
          modelId: modelId,
          stageType: this.datevalue,
          data: stagelist
        }
        editCustomerStage(data).then((res) => {
          if (res.data.code == 200) {
            this.load();
            _g.toastMsg('success', '保存成功')
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      },
      load() {
        let modelId = this.$route.query.id
        getCusStageList(modelId).then((res) => {
          if (res.data.code == 200) {
            this.formInline.stage = []
            this.datevalue = res.data.result[0].stageType.toString()
            for (let i of res.data.result) {
              if (i.stageActivityEnd == 2147483647) {
                // this.formInline.stage
                i.stageActivityEnd = '+∞'
              }
              if (i.stageActivityStart == -2147483647) {
                // this.formInline.stage
                i.stageActivityStart = '-∞'
              }
              this.formInline.stage.push({
                id: i.id,
                level: i.stageName,
                stage_min_number: i.stageActivityStart,
                stage_max_number: i.stageActivityEnd
              })
            }
          }
        });
      }
    },
    mounted() {

    },
    created() {
      this.load()
    }
  };
</script>

<style scoped>
    .date-select {
        float: left;
        padding-left: 29px;
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }

    .date-label {
        margin-right: 10px;
    }

    .el-form-item_content {
        margin-left: 29px;
        margin-right: 29px;
        border: 1px solid #dcdfe6;
        border-bottom: none;
    }

    .stage-span {
        font-size: 14px;
        margin-top: 10px;
        margin-right: 10px;
        margin-left: 10px;
    }

    .stageTable tr {
        padding: 0 !important;
        height: 65px;
        line-height: 65px;
    }

    .el-select {
        width: 118px;
    }

    .top-content {
        text-align: left;
        min-height: 50px;
        background: #fff;
    }

    .top-content h4 {
        font-size: 14px;
        color: #333;
        line-height: 14px;
        margin-top: 14px;
        margin-bottom: 8px;
    }

    .tip-content {
        font-size: 12px;
        color: #333;
        line-height: 50px;
        font-weight: bold;
        padding-left: 47px;
    }

    .top-content h4 img {
        margin-left: 14px;
        display: block;
        float: left;
        margin-top: -2px;
        margin-right: 4px;
        width: 16px;
        height: 16px;
    }

    .top-content ul {
        padding-left: 0;
        list-style: none;
        margin-top: 6px;
    }

    .top-content ul li {
        font-size: 12px;
        color: #999;
        line-height: 22px;
    }

    .top-content ul li i {
        margin: 9px 6px 0 0;
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #999;
        float: left;
    }

    .bottom-content {
        background: #fff;
        padding-bottom: 20px;
    }

    .bottom-content h4 {
        font-size: 14px;
        color: #333;
        line-height: 14px;
        padding-top: 14px;
        text-align: left;
        margin-bottom: 8px;
    }

    .bottom-content h4 img {
        margin-left: 14px;
        display: block;
        float: left;
        margin-top: -2px;
        margin-right: 4px;
        width: 16px;
        height: 16px;
    }

    .item:first-child {
        margin-top: 0;
    }

    .content {
        background-color: #f0f2f5;
        width: 100%;
    }

    .edit-btn {
        display: block;
        width: 15px;
        height: 14px;
        float: left;
        background: none;
        margin: 18px 0 0 10px;
        padding: 0;
        cursor: pointer;
    }

    .save-btn {
        color: #2c8aff;
        font-style: normal;
        font-size: 12px;
        line-height: 50px;
        float: left;
        cursor: pointer;
    }

    .bottom-content .el-form-item {
        height: 40px;
        line-height: 40px;
        margin-bottom: 14px !important;
    }
</style>
